import { Component, OnInit } from '@angular/core';
import { TipoMenu } from 'src/app/_enums/TipoMenu';

@Component({
  selector: 'app-lista-registro',
  templateUrl: './lista-registro.component.html'
})
export class ListaRegistroComponent implements OnInit {
  
  public tipoMenuValue: number = TipoMenu.Checkup;

  constructor() { }

  ngOnInit() {
  }

}